<ces-asset-breadcrumb [trail]="breadcrumbTrail()" />

<main class="px-(--space-4)">
  <ces-route-title [noGap]="true">
    <ng-template #titleSuffix>
      <div class="ml-(--space-8)">
        <p-select
          data-testid="dashboard-publication-select"
          appendTo="body"
          autoOptionFocus="true"
          [filter]="publicationOptions().length >= 10"
          [options]="publicationOptions()"
          [ngModel]="selectedPostId()"
          (ngModelChange)="onSelect($event)"
          optionLabel="label"
          optionValue="id"
          [showClear]="true"
          [disabled]="publicationOptions().length === 0"
          [placeholder]="'pages.dashboard.selectPublication' | transloco"
          [ariaLabel]="'pages.dashboard.selectPublication' | transloco"
          [style]="{ width: 'var(--width-select-narrow)' }" />
      </div>
    </ng-template>
    <ces-button-secondary
      data-testid="dashboard-refresh"
      [label]="'common.buttons.refresh' | transloco"
      icon="refresh"
      [disabled]="!canRefresh()"
      (onClick)="refresh()" />
  </ces-route-title>

  <div role="region" aria-live="polite" [attr.aria-busy]="isLoadingStructure()" class="mt-(--space-6) flex flex-col gap-(--space-8)">
    @if (publicationOptions().length === 0) {
      <div data-testid="dashboard-no-publications" class="empty-state text-(color:--text-secondary) p-(--padding-card)">
        {{ 'pages.dashboard.noPublicationsForAsset' | transloco }}
      </div>
    } @else if (selectedPostId() === null) {
      <div data-testid="dashboard-empty-state" class="empty-state text-(color:--text-secondary) p-(--padding-card)">
        {{ 'pages.dashboard.noPublication' | transloco }}
      </div>
    } @else if (isLoadingStructure()) {
      <div data-testid="dashboard-loading" class="grid gap-x-(--gap-publication-grid-x) gap-y-(--space-4) grid-cols-1 sm:grid-cols-2">
        <p-skeleton height="var(--height-publication-element)" />
        <p-skeleton height="var(--height-publication-element)" />
        <p-skeleton height="var(--height-publication-element)" />
        <p-skeleton height="var(--height-publication-element)" />
      </div>
    } @else {
      @for (entry of sectionsWithElements(); track entry.section.id) {
        <div class="flex flex-col gap-(--space-2)">
          @if (entry.section.titleI18n) {
            <h3 class="[margin:0] font-semibold text-(color:--text-primary) text-base">{{ entry.section.titleI18n }}</h3>
          }
          <section
            class="flex flex-col gap-(--space-4)"
            [attr.aria-label]="entry.section.titleI18n || ('common.labels.section' | transloco)">
            <!-- Display bands, sharing the emailed rendering's model: full-width elements break
                 out, the rest stacks per column so text cards hug their content and pull the
                 cards below them up. Empty stacks stay mounted at sm+ (they pin a lone stack to
                 its grid column) but hide below sm where they would only add a dead row gap. -->
            @for (band of entry.bands; track band.key) {
              @if (band.kind === 'full') {
                <ces-automatic-post-element-renderer
                  [style.height]="cardHeight(band.element, entry.section)"
                  [element]="band.element"
                  [parentEditing]="false"
                  [assetId]="currentAssetId()" />
              } @else {
                <div
                  class="grid grid-cols-1 items-start gap-x-(--gap-publication-grid-x) gap-y-(--space-4)"
                  [class.sm:grid-cols-2]="entry.section.columns === 2">
                  <div class="flex-col gap-(--space-4) min-w-0" [class]="band.left.length > 0 ? 'flex' : 'hidden sm:flex'">
                    @for (element of band.left; track element.id) {
                      <ces-automatic-post-element-renderer
                        [style.height]="cardHeight(element, entry.section)"
                        [element]="element"
                        [parentEditing]="false"
                        [assetId]="currentAssetId()" />
                    }
                  </div>
                  @if (entry.section.columns === 2) {
                    <div class="flex-col gap-(--space-4) min-w-0" [class]="band.right.length > 0 ? 'flex' : 'hidden sm:flex'">
                      @for (element of band.right; track element.id) {
                        <ces-automatic-post-element-renderer
                          [style.height]="cardHeight(element, entry.section)"
                          [element]="element"
                          [parentEditing]="false"
                          [assetId]="currentAssetId()" />
                      }
                    </div>
                  }
                </div>
              }
            }
          </section>
        </div>
      }
    }
  </div>
</main>
